/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { defaultOptions } from "cms/components/components/link-button/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { isTrue } from "utils/empty-exists";

const ButtonCTALinkButton = (props) => {

    const { defaultStyle, defaultColour, defaultIcon } = defaultOptions;

    const link = props?.link ?? {};
    const linkProperties = props?.linkProperties ?? {};
    const linkGuid = link?.guid;
    
    // Get properties for this specific link from linkProperties
    const linkProps = linkGuid ? (linkProperties[linkGuid] || {}) : {};
    const style = linkProps?.style ?? defaultStyle;
    const colour = linkProps?.colour ?? defaultColour;
    const icon = linkProps?.icon ?? defaultIcon;

    const isExternal = link?.is_external === true;
    const internalNewTab = link?.new_tab ?? false;
    const openInNewTab = isExternal || internalNewTab;
    const target = openInNewTab ? "_blank" : "_self";
    const isExternalIcon = icon === "external";
    const isArrowIcon = icon === "arrow";

    return (
        <div className='simplicity-linkbutton'>
            <p>
                <a
                    className={`btn icon ${style} ${colour}`}
                    href={link?.url}
                    target={target}
                >
                    {link?.text}
                    {isTrue(isExternalIcon) &&
                        <span className='link-icon'>
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </span>
                    }
                    {isTrue(isArrowIcon) &&
                        <span className='link-icon'>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                    }
                </a>
            </p>
        </div>
    );
};

ButtonCTALinkButton.displayName = "ButtonCTALinkButton";
export { ButtonCTALinkButton };
